export default __webpack_public_path__ + "static/media/3.a36bb8aa.jpeg";